











import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class Button extends Vue {
  @Prop({
    type: String,
    default: '/',
    required: true
  })
  link!: string
  @Prop({
    type: String,
    required: true
  })
  title!: string
}
